import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n';

import { ChatInput } from './ChatInput';
import TextareaAutosize from 'react-textarea-autosize';
import { Icon, IconSmile, IconFileAttach, IconCheck, IconCloseCircle } from '../../../base/icons';
import SmileysPanel from './SmileysPanel';

class RPC_ChatInput extends ChatInput {
    constructor(props) {
        super(props)
        this.state = {
            ...super.state,
            message: '',
            showSmileysPanel: false,
            uploaded: false,
            uploading: false,
            selectedFile: null,
            sendingMessage: false,
        }
    }

    onFileChange = (event) => {
        this.setState({ selectedFile: event.target.files[0] });
        this.setState({ uploading: true });
        this.setState({ uploaded: false });
        var files = event.target.files;
        var file = files[0];
        let { parentApi } = APP.store.getState()['features/base/config'];
        console.log(file);
        var fd = new FormData(); 
        fd.append('file', file);
        $.ajax({ 
            url: window.API_DOMAIN+'/api/v1/upload/'+APP.conference.roomName,
            type: 'post', 
            data: fd,
            contentType: false,
            processData: false, 
            success: (res) => {
                this.setState({ uploading: false });
                this.setState({ uploaded: res });
            }
        });

    }

    _onSubmitMessage() {
        if(this.state.uploading) {
            this.setState({sendingMessage: true});
            setTimeout(()=>{
                this._onSubmitMessage();
            }, 300);
            return;
        }
        this.setState({sendingMessage: false});

        let trimmed = this.state.message.trim();
        if(this.state.uploaded) {
            trimmed = trimmed + '::attachment:' + this.state.uploaded.key + ':attachment::';
        }
        if(trimmed)
        {
            this.props.onSend(trimmed);
            this.setState({ uploaded: false, selectedFile: null, message: '' });
        }
    }

    

    render() {
        const smileysPanelClassName = `${this.state.showSmileysPanel
            ? 'show-smileys' : 'hide-smileys'} smileys-panel`;

        return (
            <div className = { `chat-input-container${this.state.message.trim().length ? ' populated' : ''}` }>
                <div id = 'chat-input' >
                    <div className = 'smiley-input'>
                        <div id = 'smileysarea'>
                            <div id = 'smileys'>
                                <div
                                    className = 'smiley-button'
                                    onClick = { this._onToggleSmileysPanel }>
                                    <Icon src = { IconSmile } />
                                </div>
                            </div>
                        </div>
                        <div className = { smileysPanelClassName }>
                            <SmileysPanel
                                onSmileySelect = { this._onSmileySelect } />
                        </div>
                    </div>
                    <div className = 'usrmsg-form'>
                        <TextareaAutosize
                            id = 'usermsg'
                            inputRef = { this._setTextAreaRef }
                            maxRows = { 5 }
                            onChange = { this._onMessageChange }
                            onHeightChange = { this.props.onResize }
                            onKeyDown = { this._onDetectSubmit }
                            placeholder = { this.props.t('chat.messagebox') }
                            value = { this.state.message } />
                    </div>
                </div>

                <div className='chat-actions'>
                    {!this.state.uploading && !this.state.uploaded &&
                        <div className="upload-btn-wrapper">
                            <button className="btn">
                                <Icon src = { IconFileAttach } />
                            </button>
                            <input type="file" name="myfile" onChange={this.onFileChange}/>
                        </div>
                    }
                    {this.state.uploaded && 
                        <>
                            <span className="file-uploaded" style={{ margin: "auto 12px" }}>
                                <Icon src = { IconCheck } />
                            </span>
                            <span style={{fontSize: "13px", maxWidth: '100px', textOverflow: "ellipsis",overflow: "hidden"}}>{this.state.selectedFile.name}</span>
                           
                            <a style={{"margin-left": "auto", "cursor": "pointer"}} tile="Remove" onClick={ this._onDeleteFile} > <Icon src = { IconCloseCircle } /></a>
                        </>
                    }
                    {this.state.uploading && !this.state.uploaded &&
                            <>
                            <div className="loading">
                                <div className="loader-a" style={{
                                    width: "20px",
                                    height: "20px"
                                }}></div>
                            </div>
                            <span style={{fontSize: "13px", maxWidth: '100px', textOverflow: "ellipsis",overflow: "hidden"}}>{this.state.selectedFile.name}</span>
                            </>
                    }
                    <a onClick={ this._onSubmitMessage } className='btn-send'>SEND</a>
                    {this.state.sendingMessage && 
                        <div className="waitMessage">
                            <div className="loading">
                                <div className="loader-a" style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    marginTop: "-15px",
                                    marginLeft: "-15px"
                                }}></div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default translate(connect()(RPC_ChatInput));